export default __webpack_public_path__ + "static/media/NTORQ 125 RACE EDITION_4.78270dcf.webp";